module.exports = __webpack_public_path__ + "static/media/tr808_kick_11.7bccfb5f.wav";